module.exports = __webpack_public_path__ + "img/DateRange.8673f2fe.svg";